import _nuxt_components_plugin_mjs_KR1HBZs4kY from "/home/bert/rtk-cc-nuxt/.nuxt/components.plugin.mjs";
import node_modules_nuxt_dist_head_runtime_lib_vueuse_head_plugin_mjs_D7WGfuP1A0 from "/home/bert/rtk-cc-nuxt/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import node_modules_nuxt_dist_pages_runtime_router_mjs_qNv5Ky2ZmB from "/home/bert/rtk-cc-nuxt/node_modules/nuxt/dist/pages/runtime/router.mjs";
import node_modules__64nuxtjs_apollo_dist_runtime_plugin_mjs_eTVJQYlCmx from "/home/bert/rtk-cc-nuxt/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
export default [
  _nuxt_components_plugin_mjs_KR1HBZs4kY,
  node_modules_nuxt_dist_head_runtime_lib_vueuse_head_plugin_mjs_D7WGfuP1A0,
  node_modules_nuxt_dist_pages_runtime_router_mjs_qNv5Ky2ZmB,
  node_modules__64nuxtjs_apollo_dist_runtime_plugin_mjs_eTVJQYlCmx
]